
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1408Dialog extends Serenity.EntityDialog<Report_1408Row, any> {
        protected getFormKey() { return Report_1408Form.formKey; }
        protected getIdProperty() { return Report_1408Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1408Row.localTextPrefix; }
        protected getNameProperty() { return Report_1408Row.nameProperty; }
        protected getService() { return Report_1408Service.baseUrl; }
        protected getDeletePermission() { return Report_1408Row.deletePermission; }
        protected getInsertPermission() { return Report_1408Row.insertPermission; }
        protected getUpdatePermission() { return Report_1408Row.updatePermission; }

        protected form = new Report_1408Form(this.idPrefix);

    }
}